<div
  class="custom-tooltip"
  [@fadeInOut]="animationState"
  [style.pointer-events]="animationState === 'visible' ? 'auto' : 'none'"
>
  {{ message }}
</div>
